export default function Numpy_ArrayReshape() {
  return <div>Numpy_ArrayReshape Component</div>;
}
